"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Store = void 0;
var indexed_db_handler_1 = require("./indexed-db-handler");
var STORE_NAME = 'store';
var Store = /** @class */ (function (_super) {
    __extends(Store, _super);
    /**
       * @param {string} storeName name of store
       * @param {number} storeVersion version of store
       */
    function Store(storeName, storeVersion) {
        return _super.call(this, storeName, storeVersion, function (event) {
            var db = event.target.result;
            if (db.objectStoreNames.contains(STORE_NAME)) {
                db.deleteObjectStore(STORE_NAME);
            }
            db.createObjectStore(STORE_NAME, { keyPath: 'key' });
        }) || this;
    }
    /**
     * @async
     * check open connection if it's close
     */
    Store.prototype.openConnection = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.db === null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.openDB()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @async
     * Add or update value in store
     * @param {string} key
     * @param {any} value
     * @returns {Promise<void>}
     */
    Store.prototype.set = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var data, isAlreadyIn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = { key: key, value: value };
                        return [4 /*yield*/, this.openConnection()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.readByKey(STORE_NAME, key)];
                    case 2:
                        isAlreadyIn = (_a.sent()) !== undefined;
                        if (isAlreadyIn) {
                            return [2 /*return*/, this.update(STORE_NAME, data)];
                        }
                        else {
                            return [2 /*return*/, this.create(STORE_NAME, data)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @async
     * Return value
     * @param {string} key
     * @returns {Promise<any>}
     */
    Store.prototype.get = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.openConnection()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.readByKey(STORE_NAME, key)];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data === null || data === void 0 ? void 0 : data.value];
                }
            });
        });
    };
    /**
     * @async
     * Delete value
     * @param {string} key
     * @returns {Promise<void>}
     */
    Store.prototype.delete = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.openConnection()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, _super.prototype.delete.call(this, STORE_NAME, key)];
                }
            });
        });
    };
    /**
     * @async
     * Return all keys
     * @returns {Promise<number[] | string[]>}
     */
    Store.prototype.keys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var datas;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.openConnection()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.read(STORE_NAME)];
                    case 2:
                        datas = _a.sent();
                        return [2 /*return*/, datas.map(function (data) { return data.key; })];
                }
            });
        });
    };
    /**
     * @async
     * Return all values
     * @returns {Promise<any[]>}
     */
    Store.prototype.values = function () {
        return __awaiter(this, void 0, void 0, function () {
            var datas;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.openConnection()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.read(STORE_NAME)];
                    case 2:
                        datas = _a.sent();
                        return [2 /*return*/, datas.map(function (data) { return data.value; })];
                }
            });
        });
    };
    /**
     * @async
     * Return entries of all pairs [key, value]
     * @returns {Promise<[string | number, any][]}
     */
    Store.prototype.entries = function () {
        return __awaiter(this, void 0, void 0, function () {
            var datas;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.openConnection()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.read(STORE_NAME)];
                    case 2:
                        datas = _a.sent();
                        return [2 /*return*/, datas.map(function (data) { return [data.key, data.value]; })];
                }
            });
        });
    };
    return Store;
}(indexed_db_handler_1.IndexedDBHandler));
exports.Store = Store;
//# sourceMappingURL=store.js.map